import { clone } from 'lodash-es';

const DefaultFields = {
  group: {
    entries: [],
  },

  'social-data': {
    visible: true,
    posts: [],
    queuedPost: null,
    map: {},
  },

  'social-group': {
    hide: false,
  },

  'social-text': {
    text: null,
    network: null,
    disable: false,
    contentAfter: null,
    contentBefore: null,
  },

  'social-multi-media': {
    src: '',
    isVideo: false,
    network: null,
    videoOptions: {
      autoplay: true,
      loop: false,
      muted: false,
      poster: null,
    },
    disable: false,
  },

  'social-network-logo': {
    disable: false,
  },

  text: {
    text: '',
  },

  image: {
    imageUrl: '',
    fillType: 'stretch',
  },

  video: {
    src: '',
    videoOptions: {
      autoplay: true,
      loop: false,
      start: 0,
      end: false,
    },
  },

  oval: {
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'cover',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
  },

  rectangle: {
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'cover',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
  },

  triangle: {
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'cover',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
  },

  slideshow: {
    cycleTime: 5000,
    entries: [],
    hasProgressIndicator: false,
    progressIndicator: {
      progressIndicatorStyle: 'stories',
    },
  },

  date: {
    format: 'EEEE MMMM do, yyyy',
    customFormat: false,
    customFormatStyle: 'EEEE MMMM do, yyyy',
    customTimeZone: false,
    customTimeZoneOffset: '-8',
    customTimeZoneName: '(GMT-08:00) Pacific Time (US & Canada)',
    customTimeZoneHasDaylightSavings: 1,
  },

  qrcode: {
    visible: true,
    permalink: 'https://tagboard.com',
    hasLogo: false,
    logoUrl: '',
    shortLink: '',
  },

  'sheet-data': {
  },

  shoppable: {},

  'data-list': {
  },

  sportradar: {},

  marquee: {
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'cover',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    speed: 2000, // speed in ms 500-4000
    reverse: false,
    entries: [], // TODO: data repeater ala slideshow
    tickerSpacing: 'infinite', // infinite, spaced
  },

    "marquee-text": {
      text: '',
    },

    "marquee-image": {
      imageUrl: '',
    },
  };

export default function getDefaultFields(type) {
  return type in DefaultFields ? clone(DefaultFields[type]) : {};
};
